import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { trackError } from '@helsenorge/framework-utils/adobe-analytics';
import { isDebug } from '@helsenorge/framework-utils/hn-debug';
import { HelsenorgeProxyError } from '@helsenorge/framework-utils/hn-proxy-service';
import { error as logError } from '@helsenorge/framework-utils/logger';
import ErrorMessage from '../error-message';
export default function withErrorBoundary(COMPONENT) {
    class GuardedComponent extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                error: false,
            };
        }
        componentDidCatch(error) {
            trackError('level3', 'Uhåndtert teknisk feil');
            this.setState({ error: true });
            if (error instanceof HelsenorgeProxyError) {
                this.setState({ correlationId: error.correlationId });
            }
            if (isDebug() || process.env.NODE_ENV !== 'production') {
                this.setState({ name: `${error.name} ${error.message}`, message: error.stack });
            }
            logError('Error in ' + COMPONENT.name + ' component or a child component', error);
        }
        render() {
            if (this.state.error) {
                return (_jsx(ErrorMessage, { label: this.state.name || (this.props.resources && this.props.resources.unknownError), description: this.state.message || (this.props.resources && this.props.resources.unknownErrorAction), correlationId: this.state.correlationId }));
            }
            return _jsx(COMPONENT, { ...this.props });
        }
    }
    return GuardedComponent;
}
